import { render, staticRenderFns } from "./paymentType.vue?vue&type=template&id=52ad01fa&scoped=true&"
import script from "./paymentType.vue?vue&type=script&lang=js&"
export * from "./paymentType.vue?vue&type=script&lang=js&"
import style0 from "./paymentType.vue?vue&type=style&index=0&id=52ad01fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad01fa",
  null
  
)

export default component.exports